import React, { useEffect, useState } from "react";
import { Briefcase, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useProductInfo } from "../../hooks/useProductInfo";
import { buildBusinessPath } from "../../../../../../services/helpers/BusinessSlugHelper";
import "./styles/BusinessAttributionCard.css";

const BusinessAttributionCard: React.FC = () => {
  const { businessId, businessName, businessLogoUrl } = useProductInfo();
  const navigate = useNavigate();

  // Fall back to the placeholder icon if the logo fails to load (e.g. network
  // issue), instead of leaving a blank gap. Reset when the URL changes.
  const [imgError, setImgError] = useState(false);
  useEffect(() => {
    setImgError(false);
  }, [businessLogoUrl]);

  if (!businessId || !businessName) return null;

  const showLogo = businessLogoUrl && !imgError;

  return (
    <div className="biz-attr glass-card" onClick={() => navigate(buildBusinessPath(businessId, businessName))}>
      <div className="biz-attr__header">
        <Briefcase size={18} strokeWidth={2.5} />
        <span className="biz-attr__label">Listed by Business</span>
      </div>
      <div className="biz-attr__body">
        {showLogo ? (
          <img
            className="biz-attr__logo"
            src={businessLogoUrl}
            alt={businessName}
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="biz-attr__logo-placeholder">
            <Briefcase size={22} strokeWidth={2} />
          </div>
        )}
        <span className="biz-attr__name">{businessName}</span>
        <ChevronRight size={18} strokeWidth={2.5} className="biz-attr__chevron" />
      </div>
    </div>
  );
};

export default BusinessAttributionCard;
